"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Calendar, Circle, Ticket, LayoutGrid } from "lucide-react";
export default function Foundation() {
  const shouldReduceMotion = useReducedMotion();
  const cards = [{
    icon: Calendar,
    title: "Membership Portal",
    body: "Access your 3rd quarter membership dashboard. Manage your profile, view status, and stay connected with our community.",
    mockupType: "agenda"
  }, {
    icon: Ticket,
    title: "Secure Access",
    body: "Login to your private account. Your credentials remain visible only to you and the foundation administration team.",
    mockupType: "ticketing"
  }, {
    icon: LayoutGrid,
    title: "Community Impact",
    body: "Track our collective progress. See how your support helps us in making the world a better place for everyone.",
    mockupType: "tracks"
  }];
  const agendaRows = [{
    time: "09:00",
    label: "Profile"
  }, {
    time: "10:30",
    label: "Status"
  }, {
    time: "13:00",
    label: "Updates"
  }];
  const ticketTiers = [{
    label: "User",
    active: false
  }, {
    label: "Staff",
    active: false
  }, {
    label: "Admin",
    active: true
  }];
  const trackCells = [{
    track: "Goal A",
    session: "Growth",
    highlight: false
  }, {
    track: "Goal B",
    session: "Giving",
    highlight: false
  }, {
    track: "Goal C",
    session: "Impact",
    highlight: true
  }, {
    track: "Goal A",
    session: "Unity",
    highlight: false
  }, {
    track: "Goal B",
    session: "Light",
    highlight: false
  }, {
    track: "Goal C",
    session: "Love",
    highlight: false
  }];
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.08
      }
    }
  };
  const cardVariants = shouldReduceMotion ? {
    hidden: {
      opacity: 1,
      y: 0
    },
    show: {
      opacity: 1,
      y: 0
    }
  } : {
    hidden: {
      opacity: 0,
      y: 24
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.72,
        ease: [0.22, 1, 0.36, 1] as const
      }
    }
  };
  return;
}